import React, { Component } from 'react';
import {PropTypes} from 'prop-types';

class BusinessProductCategories extends Component {

  render() {
    return (
      <div className='business-list-category list-S'>
        <h3 className='business-list-category-title'>{this.props.headingTitle}</h3>
        {
          this.props.productCategories.map((item, i) => {
            return (
              <p className='business-list-category-tiem'>
                <span onClick={() => this.props.onItemClick(item)} className='item-link'>{item.name}</span>
              </p>
            );
          })
        }
      </div>
    );
  }
}

BusinessProductCategories.propTypes = {
  // productCategories: PropTypes.arrayOf('object')
  onItemClick: PropTypes.func
}

BusinessProductCategories.defaultProps = {
  headingTitle: 'DANH MỤC SẢN PHẨM'
}

export default BusinessProductCategories;



// WEBPACK FOOTER //
// ./components/business/business-page/BusinessProductCategories.jsx